<script>
  import { Modal, Button, Link } from "../../../Components";
  import { CFA } from "../../../Components/Icons";

  import PortraitPopup from "../../Component/PortraitPopup.svelte";

  export let headline;
  export let subheadline = false;
  export let attachmentInfo;
  export let companyNameBeforePerson = false;

  export let item;

  let showModal = false;

  const baseUrl = "https://kongress.fondsprofessionell.com/";
  const baseImgUrl = baseUrl + "bilder/";
  const basePdfUrl = baseUrl + "anhaenge/";
</script>

<div class="my-6 grid grid-cols-1 bg-im-gray-200 p-3 text-sm md:grid-cols-4">
  {#if headline || subheadline || item.eventTitle}
    <div class="prose prose-sm max-w-none md:col-span-3 md:col-start-2">
      {#if headline}
        <h2 class="text-theme-minor-900">{headline}</h2>
      {/if}
      {#if subheadline || item.eventTitle}
        <h3 class="font-medium">{subheadline || item.eventTitle}</h3>
      {/if}
    </div>
  {/if}
  {#if item.referent1image}
    <div class="flex flex-wrap gap-4 md:row-span-2 md:row-start-1 md:flex-col">
      <figure>
        <img src={baseImgUrl + item.referent1image} alt={item.referent1imageTitle} />
        <figcaption class="mt-1">{item.referent1imageTitle}</figcaption>
      </figure>

      {#if item.referent2image}
        <figure>
          <img src={baseImgUrl + item.referent2image} alt={item.referent2imageTitle} />
          <figcaption class="mt-1">{item.referent2imageTitle}</figcaption>
        </figure>
      {/if}
    </div>
  {/if}
  <div class="prose prose-sm mt-4 max-w-none md:col-span-3">
    <slot name="lead" />

    {#if item.eventAttachment.length}
      {#if attachmentInfo}
        <p>{attachmentInfo}</p>
      {/if}
      <div class="inline-flex flex-col gap-2">
        {#each item.eventAttachment as attachment}
          <Link rel="noreferrer" target="_blank" href={basePdfUrl + attachment.filename}>{attachment.title}</Link>
        {/each}
      </div>
    {/if}
    {#if item.eventDescription3}
      <p>{item.eventDescription3}</p>
    {/if}
    <p>
      <strong>{item.referent1name}</strong>
      {item.referent1position}
      {#if item.referent1company}, {item.referent1company}{/if}

      {#if item.referent2name}
        und <strong>{item.referent2name}</strong>
        {item.referent2position}{#if item.referent2company}, {item.referent2company}{/if}
      {/if}
    </p>
    {#if companyNameBeforePerson}
      <p>
        {#if item.haveAVPortrait == 1}
          <Button
            on:click={() => {
              showModal = true;
            }}
            link
          >
            {item.avCompanyname}
          </Button>
        {:else}
          {item.avCompanyname}
        {/if}
      </p>
    {/if}
    <p>
      <strong class="block">Zur Person:</strong>
      {item.referent1resume}
    </p>

    {#if item.referent2resume}
      <p>{item.referent2resume}</p>
    {/if}

    {#if !companyNameBeforePerson}
      <p>
        {#if item.haveAVPortrait == 1}
          <Button
            on:click={() => {
              showModal = true;
            }}
            link
          >
            {item.avCompanyname}
          </Button>
        {:else}
          {item.avCompanyname}
        {/if}
      </p>
    {/if}

    {#if item.cfa_certified == 1}
      <figure><CFA class="w-20" /></figure>
    {/if}
  </div>
  {#if $$slots.whitebox}
    <div class="mt-8 w-full rounded-lg bg-white p-2 empty:hidden md:col-span-4"><slot name="whitebox" /></div>
  {/if}
  {#if $$slots.box}
    <div class="mt-8 w-full empty:hidden md:col-span-4"><slot name="box" /></div>
  {/if}
  <slot />
</div>

{#if item.haveAVPortrait == 1}
  <Modal bind:showModal><PortraitPopup item={item.portraitData} /></Modal>
{/if}
